import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import Panjabi from "../images/panjabi.jpg";
import T_shirt from "../images/T-Shirt new.jpg";
import Jacket from "../images/Jacket.jpg";
import Blazer from "../images/blazer.jpg";

import shirt from "../images/shirt.jpg"


function Menswear() {
  return (
    <div>
      <Navbar />
      <br />
      <br />

<br/>
<br/>
      <div className='ranaghatsaree'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Mens Wear</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='MenPunjabi'>
                    <div className="card">
                      <img src={Panjabi} className="card-img-top" alt="Panjabi"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Panjabi</h5>
                        <p className="card-text">Best panjabi available</p>
                        <a href="MenPunjabi" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
      
                <div className="col-md-6 mt-3">
                  <a href='T_shirt'>
                    <div className="card" >

                      <img src={T_shirt} className="card-img-top" alt="Mena T_shirt" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">T-Shirt</h5>
                        <p className="card-text">Best T-Short products</p>
                        <a href="T_shirt" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>

<div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='MenBlazer'>
                    <div className="card">
                      <img src={Blazer} className="card-img-top" alt="Blazer"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Blazer</h5>
                        <p className="card-text">Best Blazer available</p>
                        <a href="MenBlazer" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
      
                <div className="col-md-6 mt-3">
                  <a href='#'>
                    <div className="card" >

                      <img src={Jacket} className="card-img-top" alt="Mena Jacket" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Jacket</h5>
                        <p className="card-text">Best Jacket products</p>
                        <a href="#" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>



          </div>
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='shirt'>
                    <div className="card">
                      <img src={shirt} className="card-img-top" alt="men shirt" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Shirt</h5>
                        <p className="card-text">Best Shirt available</p>
                        <a href="shirt" className="learnmore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                {/* <div className="col-md-6 mt-3">
                  <a href='top'>
                    <div className="card" >

                      <img src={Blazer} className="card-img-top" alt="Blazer"/>
                      <div className="card-body">
                        <h5 className="card-title mb-1">Fancy crop top</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="top" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div> */}
              </div>
            </div>





          </div>
        </div>
      </div>
      <br />
    </div>
  )
}

export default Menswear